import * as React from 'react';

import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { enPaymentMethod } from 'enums/enPaymentMethod';
import { cartService } from 'services/CartService';
import { paymentService } from 'services/PaymentService';
import { IPaymentModel } from 'interfaces/IPaymentModel';
import { parameterService } from 'services/ParameterService';
import { enParameters } from 'enums/enParameters';
import { langService } from 'services/LangService';
import { enLang } from 'interfaces/IProductData';
import CardItem from './CardItem';
import { WithStyles } from 'shared/decorators/withStyles';

interface IState extends IStateBase<IPaymentModel> {
  allCards: enPaymentMethod[];
  cards: enPaymentMethod[];
  limit?: number;
}

interface IProps {
  index: number;
  limit?: number;
}

@WithStyles(() => ({
  component: {
    '& .chk-payment-flags': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      marginBottom: '15px',
      height: '60px',
      '&.selected': {
        '& .chk-flag-option': {
          opacity: 0.2,
          '&.selected': {
            opacity: 1
          }
        }
      },
      '& .chk-flag-option': {
        margin: '10px 5px',
        width: '55px',
        height: 'auto',
        transition: 'all 250ms ease-in-out',
        cursor: 'pointer',
        '&:hover': {
          opacity: 1,
          width: '70px',
          height: '50px'
        }
      }
    }
  }
}))
export default class PaymentMethod extends BaseComponent<IState, IProps, IPaymentModel> {
  constructor(props: any) {
    super(props);

    this.state = {
      allCards: Object.keys(enPaymentMethod).map<enPaymentMethod>(key => enPaymentMethod[key]),
      cards: [],
      limit: 10000
    };
  }

  componentDidMount() {
    this.bindModel(paymentService.getPayment(this.props.index));

    if (this.props.limit) {
      this.setState({ limit: this.props.limit });
    }

    cartService
      .getCart()
      .combineLatest(
        paymentService.isMultipleCreditCards(),
        parameterService.get(enParameters.b),
        parameterService.get(enParameters.bs),
        langService.getLang()
      )
      .map(([productData, isMultipleCards, parameterBankslip, hideBankSlip, lang]) => {
        const toRemove = [enPaymentMethod.FREE, enPaymentMethod.ONE_CLICK_BUY];

        if (
          !productData.config.enableBankslip ||
          (parameterBankslip && Number(parameterBankslip) === 0) ||
          hideBankSlip !== null
        ) {
          toRemove.push(enPaymentMethod.BOLETO);
        }

        if (parameterBankslip && Number(parameterBankslip) === 1) {
          const index = toRemove.indexOf(enPaymentMethod.BOLETO);
          if (index > -1) {
            toRemove.splice(index, 1);
          }
        }

        if (lang !== enLang.PT_BR) {
          toRemove.push(enPaymentMethod.BOLETO);
        }

        if (!productData.config.enablePaypal) {
          toRemove.push(enPaymentMethod.PAYPAL);
        }

        if (isMultipleCards) {
          toRemove.push(enPaymentMethod.PAYPAL, enPaymentMethod.BOLETO);
        }

        if (!productData.config.enableCreditcard) {
          const creditCards = [
            enPaymentMethod.MASTERCARD,
            enPaymentMethod.VISA,
            enPaymentMethod.AMEX,
            enPaymentMethod.ELO,
            enPaymentMethod.DINERS,
            enPaymentMethod.HIPER,
            enPaymentMethod.OTHER
          ];

          toRemove.push(...creditCards);
        }

        return toRemove;
      })
      .map(toRemove => {
        return this.state.allCards.filter(i => toRemove.indexOf(i) < 0);
      })
      .bindComponent(this)
      .subscribe(cards => {
        this.setState({
          cards
        });
      });
  }

  selectPaymentMethod = (method: enPaymentMethod) => {
    const data: any = { paymentMethod: method };

    if ([enPaymentMethod.BOLETO, enPaymentMethod.PAYPAL, enPaymentMethod.OTHER].includes(method)) {
      data.brand = null;
      data.creditCard = '';
    } else if (!data.brand) {
      data.brand = method;
    }

    paymentService.setPaymentData(this.props.index, data);
  };

  render() {
    if (!this.state.model) {
      return <div />;
    }

    const { model, cards, limit } = this.state;

    const mustHaveCards = cards.filter(
      c => [enPaymentMethod.OTHER, enPaymentMethod.BOLETO, enPaymentMethod.PAYPAL].indexOf(c) >= 0
    );
    const allCards = cards.filter(c => mustHaveCards.indexOf(c) < 0);

    while (allCards.length + mustHaveCards.length > limit) {
      allCards.pop();
    }

    const selectedCards = [...allCards, ...mustHaveCards];

    const selected = model.brand || model.paymentMethod;

    return (
      <div className={this.props.classes.component}>
        <div className={`chk-payment-flags ${selected ? 'selected' : null}`}>
          {selectedCards.map(card => (
            <CardItem
              index={this.props.index}
              key={card}
              card={card}
              selected={selected}
              onSelect={this.selectPaymentMethod}
            />
          ))}
        </div>
      </div>
    );
  }
}
